import PropTypes from 'prop-types';

/**
 * Supported content alignments.
 */
export const CONTENT_ALIGNMENT = {
	LEFT: 'left',
	RIGHT: 'right',
	TOP: 'top',
	BOTTOM: 'bottom',
	TOP_LEFT: 'topLeft',
	TOP_RIGHT: 'topRight',
	BOTTOM_LEFT: 'bottomLeft',
	BOTTOM_RIGHT: 'bottomRight',
};

/**
 * Custom `prop-types` handler function validator.
 * Ensures property is of expected type and within expected range of [0, 5000].
 * @param {Object} props all JSX attributes passed to component.
 * @param {string} propName key of target property.
 * @param {string} componentName name of component.
 * @returns {Error|undefined} raised error message if validation fails.
 */
const isValidInterval = (props, propName, componentName) => {
	if (props.hasOwnProperty(propName)) {
		const type = typeof props[propName];
		if (!(type === 'number')) {
			return new Error(
				'Invalid prop `' +
					propName +
					'` of type `' +
					type +
					'` supplied to `' +
					componentName +
					'`, expected `number`.'
			);
		} else {
			const val = props[propName];
			if (val < 0) {
				return new Error(
					'Invalid prop `' +
						propName +
						'` of value `' +
						val +
						'` supplied to `' +
						componentName +
						'`, expected non-negative value.'
				);
			}
			if (val > 5000) {
				return new Error(
					'Invalid prop `' +
						propName +
						'` of value `' +
						val +
						'` supplied to `' +
						componentName +
						'`, cannot exceed `5000`.'
				);
			}
		}
	}

	return;
};

export const propTypes = {
	activateOn: PropTypes.oneOf(['click', 'focus', 'hover', 'multiple']),
	align: PropTypes.oneOf(
		Object.keys(CONTENT_ALIGNMENT).map(key => CONTENT_ALIGNMENT[key])
	),
	children: PropTypes.element.isRequired,
	content: PropTypes.node,
	enterDelay: PropTypes.number,
	leaveDelay: PropTypes.number,
	open: PropTypes.bool,
	/**
	 * Temporarily open the tooltip.
	 */
	peek: PropTypes.bool,
	/**
	 * Millisecond interval for tooltip to remain open.
	 */
	peekInterval: isValidInterval,
	showArrow: PropTypes.bool,
};

export const defaultProps = {
	activateOn: 'hover',
	align: 'right',
	content: 'Tooltip',
	showArrow: false,
};
